const ALLOWED_EXTENSIONS_FALLBACK = ['.png', '.pdf', '.jpg']

export { ALLOWED_EXTENSIONS_FALLBACK }
